// El aviso de "llegó la hora de publicar" — MOCKEADO a propósito.
//
// Las notificaciones se están construyendo en otra rama. Este archivo existe
// para que el resto del calendario se escriba contra su forma final y no contra
// un `TODO` desparramado: cuando aquella rama aterrice se cambia el cuerpo de
// `avisarQueTocaPublicar` y NADA más se entera.
//
// Por eso tampoco simula de más —no hay timers ni colas— : lo único que tiene
// que ser verdad hoy es la FIRMA. Un mock que finge trabajar invita a creerle.

export interface AvisoDePost {
  postId: string;
  lanzamientoId: string;
  /** Lo que el usuario va a leer en la notificación. */
  titulo: string;
  cuando: Date;
}

export interface ResultadoDeAviso {
  /** `false` mientras las notificaciones no existan. */
  enviado: boolean;
  motivo: string;
}

/**
 * Todavía no avisa nada.
 *
 * Devuelve `enviado: false` en vez de `true`: si mintiera, la pantalla diría
 * "te avisamos" y el usuario se perdería el post confiando en eso. Que la
 * pantalla tenga que decir la verdad es justamente lo que queremos que pase
 * hasta que el aviso exista.
 */
export async function avisarQueTocaPublicar(_aviso: AvisoDePost): Promise<ResultadoDeAviso> {
  return { enviado: false, motivo: "Las notificaciones todavía no están conectadas" };
}

/** Si hoy el sistema puede avisar. La pantalla lo usa para no prometer de más. */
export function losAvisosFuncionan(): boolean {
  return false;
}

/**
 * Si tiene sentido preguntarle al usuario qué pasa cuando llega la hora.
 *
 * Hoy NO: ni el aviso ni el publicador automático existen, así que las dos
 * opciones hacen exactamente lo mismo —nada— y elegir entre ellas es decorado.
 * Mientras estuvo a la vista hubo que acompañarla de un cartelito explicando que
 * todavía no pasa nada, o sea una pregunta y su desmentida juntas; se esconden
 * las dos (ADR-2026-09-16-si-las-dos-opciones-hacen-lo-mismo-no-hay-que-preguntar).
 *
 * Lo que la sostiene NO se borra: `modo_publicacion` se sigue guardando con su
 * default y el interruptor y su modal siguen escritos. El día que el publicador
 * exista, esto devuelve `true` y vuelve todo.
 */
export function sePuedeElegirQuePasaALaHora(): boolean {
  return false;
}

/**
 * Si el calendario de Instagram (`/instagram`) muestra "Publicar automáticamente" —
 * ADR-2026-10-28-instagram-publica-el-calendario.
 *
 * El publicador ya existe (backend, cola `instagram`), pero Meta todavía no aprobó el permiso de
 * publicar para cualquier cuenta: hasta entonces, sólo dev testers. Es aparte de
 * `sePuedeElegirQuePasaALaHora`, que gobierna la pantalla vieja del lanzamiento: ésa mira la
 * conexión vieja de n8n y no se reabre.
 */
export const PUBLICAR_SOLO_PARA_TODOS = false;

export function sePuedePublicarSolo(isDevTester: boolean | null | undefined): boolean {
  return PUBLICAR_SOLO_PARA_TODOS || isDevTester === true;
}

/**
 * Si `/instagram` muestra "Métricas" (el dashboard) y el "Cómo le fue" de los posts publicados —
 * ADR-2026-10-29-dashboard-de-metricas-de-instagram.
 *
 * El permiso de métricas ya está aprobado para todos (y el chat ya las lee), pero la pantalla es
 * nueva: la prueban los dev testers antes de abrirla.
 */
export const METRICAS_PARA_TODOS = false;

export function seVenLasMetricas(isDevTester: boolean | null | undefined): boolean {
  return METRICAS_PARA_TODOS || isDevTester === true;
}
